import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { InvestImagePanelContent } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { useSourceImages } from './hooks/use-source-images';
import { AdsStudioAddAssetPanel } from './add-asset-panel';

export const InvestImagePanel = (props) => {
  const {
    i18n,
    aid, cid, oDataConfig,
    dataService, logger, notificationApi, navigation, open, perfMarker,
  } = props;
  const {
    setSelectedImages, onInvestClickSelect, showBlocker, selectedImages,
  } = useSourceImages({
    dataService, logger, navigation, perfMarker,
  });

  const dismiss = useCallback(() => {
    navigation.goBack();
  }, [navigation]);

  return (
    <AdsStudioAddAssetPanel
      aid={aid}
      i18n={i18n}
      dismiss={dismiss}
      isOpen={open}
      showBlocker={showBlocker}
      selectedAsset={selectedImages}
      headerText={i18n.getString(_TL_('Images from Microsoft Invest'))}
      logger={logger}
      notificationApi={notificationApi}
      onClickSelect={onInvestClickSelect}
    >
      <InvestImagePanelContent i18n={i18n} aid={aid} cid={cid} oDataConfig={oDataConfig} setSelectedImages={setSelectedImages} logger={logger} />
    </AdsStudioAddAssetPanel>
  );
};

InvestImagePanel.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  navigation: PropTypes.shape({ gotoImagesPage: PropTypes.func }).isRequired,
  dataService: PropTypes.shape({
    uploadImage: PropTypes.func,
    uploadStockImage: PropTypes.func,
    uploadImageByUrl: PropTypes.func,
    uploadInvestImage: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  aid: PropTypes.number.isRequired,
  cid: PropTypes.number.isRequired,
  oDataConfig: PropTypes.shape({}).isRequired,
  notificationApi: PropTypes.shape({
    showWarning: PropTypes.func,
  }).isRequired,
  open: PropTypes.bool.isRequired,
};
